export default __webpack_public_path__ + "static/media/3.67c137d2.jpeg";